import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {observer} from 'mobx-react'
import classNames from 'classnames'

import styles from './SettingsGroup.less'

@observer export default class SettingsGroup extends Component {
    render() {
        const {title, className, titleClassName, children} = this.props

        return (
            <div className={classNames(styles['block'], className)}>
                {
                    title ? (
                        <h2 className={classNames(styles['label'], titleClassName)}>{title}</h2>
                    ) : (null)
                }

                {children}
            </div>
        )
    }
}

SettingsGroup.propTypes = {
    title: PropTypes.any,
}
